// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1O3xl","productName":"Table_productName__1-h5u"};